<template>
  <div class="notif-body">
    <div class="wording">
      <span class="notif-link" @click="goToUserInfo">{{ notif.payload.jsoncontent.user.firstName }} {{ notif.payload.jsoncontent.user.lastName }}</span>
      <span> {{ $t('notification.notifPostInCommunity.has') }} </span>
      <span class="notif-link" @click="goToPost">{{ $t('notification.notifPostInCommunity.posted') }}</span>
      <span> {{ $t('notification.notifPostInCommunity.in') }} </span>
      <span class="notif-link" @click="goToCommunity">{{ truncateText(notif.payload.jsoncontent.CommunityName) }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotifPostInCommunity',
  props: {
    notif: {
      type: Object,
      required: true
    }
  },
  methods: {
    goToUserInfo () {
      this.$store.dispatch('showHidePanel', 'NOTIF')
      this.$store.dispatch('markNotificationIsRead', this.notif.id)
      this.$router.push({ name: 'userInfo', params: { id: this.notif.payload.jsoncontent.user.id } })
    },
    goToCommunity () {
      this.$store.dispatch('showHidePanel', 'NOTIF')
      this.$store.dispatch('markNotificationIsRead', this.notif.id)
      this.$router.push({ name: 'communityPage', params: { id: this.notif.payload.jsoncontent.idCommunity } })
    },
    goToPost () {
      this.$store.dispatch('showHidePanel', 'NOTIF')
      this.$store.dispatch('markNotificationIsRead', this.notif.id)
      this.$router.push({ name: 'postPage', params: { id: this.notif.payload.jsoncontent.postId } })
    },
    truncateText (str) {
      if (str.length > 50) {
        return str.substring(0, 47) + '...'
      } else {
        return str
      }
    }
  }
}
</script>

<style lang="scss" scoped src="./NotifStyle.scss"></style>
